/* Announcement bar — sale mode.
   Ticks the countdown and handles the click-to-copy discount chip.
   At zero, swaps the parked evergreen announcement back in, so a page
   cached before the deadline still corrects itself in the browser. */
(function () {
  var bar = document.querySelector('[data-announcement-sale]');
  if (!bar) return;

  /* ----- Countdown ----- */
  var countdown = bar.querySelector('[data-countdown]');
  var endTs = countdown ? parseInt(countdown.getAttribute('data-end-ts'), 10) : 0;
  /* Real timestamp the clock is allowed to appear at — not a fake
     deadline, just when the honest one gets close enough to show. Only
     matters for a page left open across the threshold; the initial
     [hidden] state was already set server-side for the common case. */
  var revealTs = countdown ? parseInt(countdown.getAttribute('data-reveal-ts'), 10) : 0;
  var timer = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setUnit(key, text, hidden, separated) {
    var unit = countdown.querySelector('[data-unit="' + key + '"]');
    if (!unit) return;
    unit.hidden = hidden;
    unit.classList.toggle('has-sep', separated);
    unit.querySelector('[data-value]').textContent = text;
  }

  function expire() {
    if (timer) clearInterval(timer);
    var row = bar.querySelector('[data-sale-row]');
    var evergreen = bar.querySelector('[data-evergreen]');
    if (row) row.hidden = true;
    if (evergreen) evergreen.hidden = false;
    bar.classList.remove('announcement-bar--sale');
    /* Restore the quieter PDP surface the sale was suppressing. */
    if (bar.hasAttribute('data-pdp')) {
      bar.classList.add('announcement-bar--pdp-dim');
    }
  }

  function tick() {
    var nowTs = Math.floor(Date.now() / 1000);
    var remaining = endTs - nowTs;
    if (remaining <= 0) {
      expire();
      return;
    }
    if (countdown.hidden && revealTs && nowTs >= revealTs) {
      countdown.hidden = false;
    }
    var d = Math.floor(remaining / 86400);
    var h = Math.floor((remaining % 86400) / 3600);
    var m = Math.floor((remaining % 3600) / 60);
    var s = remaining % 60;

    /* Leading zero units drop off, and a unit shows its colon only when
       something visible precedes it. */
    var showD = d > 0;
    var showH = showD || h > 0;
    setUnit('d', pad(d), !showD, false);
    setUnit('h', pad(h), !showH, showD);
    setUnit('m', pad(m), false, showH);
    setUnit('s', pad(s), false, true);
  }

  if (countdown && endTs > 0) {
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ----- Click-to-copy code chip ----- */
  var chip = bar.querySelector('[data-copy-code]');
  if (!chip) return;

  var status = bar.querySelector('[data-copy-status]');
  var label = chip.querySelector('[data-code-label]');
  var code = chip.getAttribute('data-copy-code');
  var original = label.textContent;
  var revert = null;

  function confirmCopy() {
    label.textContent = 'Copied';
    chip.classList.add('is-copied');
    if (status) status.textContent = 'Discount code ' + code + ' copied';
    if (revert) clearTimeout(revert);
    revert = setTimeout(function () {
      label.textContent = original;
      chip.classList.remove('is-copied');
      if (status) status.textContent = '';
    }, 2000);
  }

  /* Fallback for a denied or unsupported clipboard: select the code so the
     customer can copy it by hand. Deliberately non-destructive — an earlier
     version disabled the chip here, which dropped it out of the tab order
     and left keyboard users with a dead pill they could not even focus. */
  function selectForManualCopy() {
    var range = document.createRange();
    range.selectNodeContents(label);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    chip.classList.add('announcement-bar__code--static');
    if (status) status.textContent = 'Discount code ' + code + ' selected. Copy it with Control or Command + C.';
  }

  var canCopy = !!(navigator.clipboard && navigator.clipboard.writeText);
  if (!canCopy) {
    chip.setAttribute('aria-label', 'Select discount code ' + code + ' to copy');
  }

  chip.addEventListener('click', function () {
    if (!canCopy) {
      selectForManualCopy();
      return;
    }
    navigator.clipboard.writeText(code).then(confirmCopy, selectForManualCopy);
  });
})();
